module.exports = __webpack_public_path__ + "static/media/icon8u.d9779bc0.svg";